module.exports = __webpack_public_path__ + "static/img/5021_phase_function_Paper_PointsHejduk_Prediction.5bd51f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5021_phase_function_Paper_PointsHejduk_Prediction.png
// module id = woO4
// module chunks = 0